module.exports = __webpack_public_path__ + "static/media/nodataTutorial.f01689f9.svg";